import { useParams, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

// Map URL entities to their corresponding section IDs
const ENTITY_TO_SECTION_MAP: Record<string, string> = {
	'linked-accounts': 'linked-accounts',
	'billing-profiles': 'billing-profiles',
	'users': 'workspace-users',
	'locations': 'workspace-locations',
	'domains': 'workspace-domains',
	'phone-numbers': 'workspace-phone-numbers',
	'data-sources': 'workspace-data-sources',
	'connections': 'workspace-connections',
}

export function useSettingsRouteState() {
	const { workspaceId, entity, recordId } = useParams<{
		workspaceId: string
		entity?: string
		recordId?: string
	}>()
	const navigate = useNavigate()

	// Scroll to the appropriate section when entity changes
	useEffect(() => {
		if (entity && ENTITY_TO_SECTION_MAP[entity]) {
			const sectionId = ENTITY_TO_SECTION_MAP[entity]
			setTimeout(() => {
				document.getElementById(sectionId)?.scrollIntoView({ 
					behavior: 'smooth', 
					block: 'start' 
				})
			}, 100)
		}
	}, [entity])

	const isNew = recordId === 'add'
	const isPanelOpen = !!(entity && recordId)

	const openCreate = (targetEntity: string) => {
		navigate(`/${workspaceId}/settings/${targetEntity}/add`)
	}

	const openRecord = (targetEntity: string, id: string) => {
		navigate(`/${workspaceId}/settings/${targetEntity}/${id}`)
	}

	const closePanel = (targetEntity: string) => {
		navigate(`/${workspaceId}/settings/${targetEntity}`)
	}

	const navigateToEntity = (targetEntity: string) => {
		navigate(`/${workspaceId}/settings/${targetEntity}`)
	}

	return {
		entity,
		recordId,
		workspaceId: workspaceId || '',
		isNew,
		isPanelOpen,
		openCreate,
		openRecord,
		closePanel,
		navigateToEntity,
	}
}
